import { SharedStoreState } from '../types/store';

export const selectOpenIncidents = (state: SharedStoreState) => {
	return state.stylovyzeIncidents.openIncidents;
};

export const selectActiveIncidents = (state: SharedStoreState) =>
	state.stylovyzeIncidents.activeIncidents;
